export const food = [
  {
    id: 1,
    name: "Baked Chicken Wings",
    img: "https://img.freepik.com/free-photo/baked-chicken-wings-asian-style-tomatoes-sauce-plate_2829-10657.jpg?size=626&ext=jpg&ga=GA1.1.1589028996.1645179880",
    desc: "Baked chicken wings in the asian style and tomatoes sauce on plate",
    price: 3000,
  },
  {
    id: 2,
    name: "Ganished Jollof Rice",
    img: "https://img.freepik.com/free-photo/delicious-food-white-plate_144627-34705.jpg?t=st=1650974513~exp=1650975113~hmac=2c70b54911dbc0efd138b1752c7516f4ea813a452f07f047a06e5049a37b66f9&w=1380",
    desc: "Closeup of roasted meat with sauce, vegetables and fries",
    price: 3000,
  },
  {
    id: 3,
    name: "Fries",
    img: "https://img.freepik.com/free-photo/closeup-roasted-meat-with-sauce-vegetables-fries-plate-table_181624-35847.jpg?t=st=1650974513~exp=1650975113~hmac=27cb7918c19cd420c8745871d7cc1c006e63fc461969581dc86542e284c84f24&w=1380",
    desc: "Baked chicken wings in the asian style and tomatoes sauce on plate",
    price: 3000,
  },
  {
    id: 4,
    name: "Sausage Fried Rice",
    img: "https://img.freepik.com/free-photo/sausage-fried-rice-with-tomatoes-carrots-shiitake-mushrooms-plate_1150-27184.jpg?t=st=1650974513~exp=1650975113~hmac=e3339ee2e5e6c3bf44a8561da8b1b4adaa0f83929ede51f94ede5b82d25cf3eb&w=1380",
    desc: "Sausage fried rice with tomatoes, carrots and shiitake mushrooms",
    price: 3000,
  },
  {
    id: 5,
    name: "Mix Pizza",
    img: "https://img.freepik.com/free-photo/mix-pizza-chicken-tomato-bell-pepper-olives-mushroom-side-view_141793-3167.jpg?t=st=1650977574~exp=1650978174~hmac=afdbc939798e29e4a774e6009b8fe2ef3efb83346d35172c5b236bf901c76b6a&w=1380",
    desc: "Mix pizza chicken tomato bell pepper olives mushroom",
    price: 3000,
  },
  {
    id: 6,
    name: "pizza with chicken",
    img: "https://img.freepik.com/free-photo/top-view-pizza-with-chicken-green-chili-pepper-tomatoes-cheese-table_141793-3055.jpg?w=1380",
    desc: "Top view of pizza with chicken green chili pepper tomatoes and cheese",
    price: 3000,
  },
  {
    id: 7,
    name: "Fresh Salad",
    img: "https://img.freepik.com/free-photo/fresh-salad-with-turkey-eggs-vegetables_1220-5193.jpg?t=st=1650977898~exp=1650978498~hmac=abd1c9e0095a1a440c9ee492b5072312c5a5479aa4c8f29c8b7430cff8bf46c4&w=1380",
    desc: "Fresh salad with turkey, eggs and vegetables ",
    price: 3000,
  },
  {
    id: 8,
    name: "Iced Cola",
    img: "https://img.freepik.com/free-photo/glass-cola-with-ice_1339-2536.jpg?size=626&ext=jpg&ga=GA1.2.1589028996.1645179880",
    desc: "Glass of cola with ice",
    price: 3000,
  },
  {
    id: 9,
    name: "Kiwi Drink",
    img: "https://img.freepik.com/free-vector/healthy-fresh-kiwi-smoothie-glass-with-straw-healthy-food-breakfast-cartoon-vector-illustration-white-background_223337-4604.jpg?w=826",
    desc: "Healthy fresh kiwi smoothie",
    price: 3000,
  },
  {
    id: 10,
    name: "Soda",
    img: "https://img.freepik.com/free-vector/realistic-pear-soda-advertisement_52683-8101.jpg?size=338&ext=jpg&ga=GA1.2.1589028996.1645179880",
    desc: "Soda Can with ice",
    price: 3000,
  },
  {
    id: 11,
    name: "Chocolate Ice Cream",
    img: "https://img.freepik.com/free-photo/plate-with-chocolate-topping-ice-cream-cups_23-2148505921.jpg?t=st=1650978757~exp=1650979357~hmac=ef33a521683158f0ca1db101b262a2cad11c6f1edb6e7e7ec8d401f2f069f550&w=1380",
    desc: "A slice of Coffee Ice Cream on an Oreo Cookie crust, and topped with Fudge and Whipped Cream.",
    price: 3000,
  },
  {
    id: 12,
    name: "Strawberry Split",
    img: "https://img.freepik.com/free-photo/ice-cream-scoop-collage-with-vanilla-chocolate-berry-scoops-topping_488220-2155.jpg?w=1380",
    desc: "Ice cream scoop collage with vanilla, chocolate and berry scoops and topping",
    price: 3000,
  },
  {
    id: 13,
    name: "Cheese Cake",
    img: "https://img.freepik.com/free-photo/homemade-newyork-cheesecake-with-frozen-berries-mint-healthy-organic-dessert-top-view_114579-9844.jpg?t=st=1650978639~exp=1650979239~hmac=be20f6e52c81001ecf58aa9584f703edbf2b8c3eb27e4fde41ecd2ac37a2d98b&w=1380",
    desc: "Homemade newyork cheesecake with frozen berries and mint,healthy organic dessert,",
    price: 3000,
  },
  {
    id: 14,
    name: "Tiramisu Cake",
    img: "https://img.freepik.com/free-photo/delicious-tiramisu-cake-with-fresh-berries-mint-plate_78677-43.jpg?w=1380",
    desc: "Delicious tiramisu cake with fresh berries and mint",
    price: 3000,
  },
  {
    id: 15,
    name: "Berry Smoothie",
    img: "  https://img.freepik.com/free-photo/berry-smoothie-with-mint-blueberry-raspberry_93675-129437.jpg?size=626&ext=jpg&ga=GA1.2.1589028996.1645179880",
    desc: "Berry smoothie with mint, blueberry and raspberry",
    price: 3000,
  },
];

export const desserts = [
  {
    id: 1,
    name: "Chocolate Ice Cream",
    img: "https://img.freepik.com/free-photo/plate-with-chocolate-topping-ice-cream-cups_23-2148505921.jpg?t=st=1650978757~exp=1650979357~hmac=ef33a521683158f0ca1db101b262a2cad11c6f1edb6e7e7ec8d401f2f069f550&w=1380",
    desc: "A slice of Coffee Ice Cream on an Oreo Cookie crust, and topped with Fudge and Whipped Cream.",
    price: 3000,
  },
  {
    id: 2,
    name: "Strawberry Split",
    img: "https://img.freepik.com/free-photo/ice-cream-scoop-collage-with-vanilla-chocolate-berry-scoops-topping_488220-2155.jpg?w=1380",
    desc: "Ice cream scoop collage with vanilla, chocolate and berry scoops and topping",
    price: 3000,
  },
  {
    id: 3,
    name: "Cheese Cake",
    img: "https://img.freepik.com/free-photo/homemade-newyork-cheesecake-with-frozen-berries-mint-healthy-organic-dessert-top-view_114579-9844.jpg?t=st=1650978639~exp=1650979239~hmac=be20f6e52c81001ecf58aa9584f703edbf2b8c3eb27e4fde41ecd2ac37a2d98b&w=1380",
    desc: "Homemade newyork cheesecake with frozen berries and mint,healthy organic dessert,",
    price: 3000,
  },
  {
    id: 4,
    name: "Tiramisu Cake",
    img: "https://img.freepik.com/free-photo/delicious-tiramisu-cake-with-fresh-berries-mint-plate_78677-43.jpg?w=1380",
    desc: "Delicious tiramisu cake with fresh berries and mint",
    price: 3000,
  },
  {
    id: 5,
    name: "Berry Smoothie",
    img: "  https://img.freepik.com/free-photo/berry-smoothie-with-mint-blueberry-raspberry_93675-129437.jpg?size=626&ext=jpg&ga=GA1.2.1589028996.1645179880",
    desc: "Berry smoothie with mint, blueberry and raspberry",
    price: 3000,
  },
];

export const drinks = [
  {
    id: 1,
    name: "Iced Cola",
    img: "https://img.freepik.com/free-photo/glass-cola-with-ice_1339-2536.jpg?size=626&ext=jpg&ga=GA1.2.1589028996.1645179880",
    desc: "Glass of cola with ice",
    price: 3000,
  },
  {
    id: 2,
    name: "Kiwi Drink",
    img: "https://img.freepik.com/free-vector/healthy-fresh-kiwi-smoothie-glass-with-straw-healthy-food-breakfast-cartoon-vector-illustration-white-background_223337-4604.jpg?w=826",
    desc: "Healthy fresh kiwi smoothie",
    price: 3000,
  },
  {
    id: 3,
    name: "Soda",
    img: "https://img.freepik.com/free-vector/realistic-pear-soda-advertisement_52683-8101.jpg?size=338&ext=jpg&ga=GA1.2.1589028996.1645179880",
    desc: "Soda Can with ice",
    price: 3000,
  },
];